import { useState, useEffect } from 'react'
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai'
import { watchlistService } from '../services/watchlist.service'
import { toast } from '../services/toast.service'

const WatchlistButton = ({ media, variant = 'icon' }) => {
  const [saved, setSaved] = useState(() => watchlistService.isSaved(media.id))

  useEffect(() => {
    const sync = () => setSaved(watchlistService.isSaved(media.id))
    window.addEventListener(watchlistService.EVENT, sync)
    return () => window.removeEventListener(watchlistService.EVENT, sync)
  }, [media.id])

  const handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const added = watchlistService.toggle(media)
    const title = media.title || media.name || 'Title'
    toast(
      added ? `Added “${title}” to My List` : `Removed “${title}” from My List`,
      'like'
    )
  }

  if (variant === 'label') {
    return (
      <button
        className={`btn watchlist-label ${saved ? 'saved' : ''}`}
        onClick={handleClick}
      >
        {saved ? <AiFillHeart /> : <AiOutlineHeart />}
        {saved ? 'In My List' : 'Add to List'}
      </button>
    )
  }

  return (
    <button
      className={`watchlist-btn ${saved ? 'saved' : ''}`}
      onClick={handleClick}
      aria-label={saved ? 'Remove from My List' : 'Add to My List'}
      title={saved ? 'Remove from My List' : 'Add to My List'}
    >
      {saved ? <AiFillHeart /> : <AiOutlineHeart />}
    </button>
  )
}

export default WatchlistButton
